export default __webpack_public_path__ + "static/splunk-aee47e89b8bebc05bcfffe4f22aaa023.png";